import { render, staticRenderFns } from "./modal_pagar_comandas.vue?vue&type=template&id=7f33ace3&scoped=true&"
import script from "./modal_pagar_comandas.vue?vue&type=script&lang=js&"
export * from "./modal_pagar_comandas.vue?vue&type=script&lang=js&"
import style0 from "./modal_pagar_comandas.vue?vue&type=style&index=0&id=7f33ace3&scoped=true&lang=css&"
import style1 from "./modal_pagar_comandas.vue?vue&type=style&index=1&id=7f33ace3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f33ace3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VCardTitle,VDialog,VDivider,VIcon,VSelect,VSimpleTable,VSpacer,VTextField,VToolbar,VToolbarTitle})
